import React from 'react';

const InvitationSection = () => {
  return (
    <section className="my-5 invitation-section">
      <div className="invitation-alert">
        <strong>Розпочато розсилання запрошень</strong>
        <span className="date d-block">1 квітня 2025 року</span>
        <p className="mt-3">
          В Системі електронного запису дітей до комунальних закладів дошкільної освіти "СЕЗ ЗДО" 
          з 01.04.2025 року розпочато розсилання автоматичних запрошень до дитячих садків на 
          2025/2026 навчальний рік. Слідкуйте за особистим кабінетом.
        </p>
      </div>
      
      <div className="carousel-navigation">
        <div className="carousel-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
        </div>
        <div className="carousel-arrows">
          <a href="#" className="arrow"><i className="fa-solid fa-chevron-left"></i></a>
          <a href="#" className="arrow"><i className="fa-solid fa-chevron-right"></i></a>
        </div>
      </div>
    </section>
  );
};

export default InvitationSection;